'use es6';

import * as Actions from 'FormsUI/actions/NotificationPreferences';
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import { parseSubmissionFormsNotificationPreferences } from 'FormsUI/utils/NotificationPreferences';
const INIT_STATE = {
  preferences: {},
  requestState: RequestState.NOT_REQUESTED
};
export function notificationPreferences(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_NOTIFICATION_PREFERENCES:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_NOTIFICATION_PREFERENCES:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_NOTIFICATION_PREFERENCES:
      return Object.assign({}, state, {
        preferences: parseSubmissionFormsNotificationPreferences(action.preferences)
      });
    case Actions.FAILED_GETTING_NOTIFICATION_PREFERENCES:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    default:
      return state;
  }
}